import React, { ReactNode, useEffect } from 'react';
import ClayLayout from '@clayui/layout';
import './WrapperComponent.css';
import Breadcrumbs from '../Breadcrumbs/Breadcrumbs';

interface WrapperProps {
    children: ReactNode;
    hidePartnershipSection?: boolean;
    forceLTR?: boolean;
}

const WrapperComponent = ({ children, hidePartnershipSection = false, forceLTR = false }: WrapperProps) => {
    useEffect(() => {
        const partnershipSection = document.querySelector('.partnership-section') as HTMLElement;
        if (partnershipSection) {
            partnershipSection.style.display = hidePartnershipSection ? 'none' : 'block';
        }
    }, [hidePartnershipSection]);

    return (
        <ClayLayout.ContentSection className="roadshow_loginform_container contact_container_loginform">
            <Breadcrumbs />
            <ClayLayout.Row className="loginform_main" style={forceLTR ? { direction: 'ltr' } : {}}>
                <ClayLayout.Col sm={12} lg={6} className="contact_img p-0 ">
                    <div className="card-cut">
                        <img
                            style={{ height: '880px', width: '100%' }}
                            src={'/o/customer-custom-element/images/hero.jpg'}
                        />
                    </div>
                </ClayLayout.Col>
                <ClayLayout.Col
                    sm={12}
                    lg={6}
                    className="main-body-container"
                    style={{
                        paddingTop: 0,
                        paddingBottom: 0,
                        paddingInlineStart: '3rem',
                        paddingInlineEnd: 0
                    }}
                >
                    {children}
                </ClayLayout.Col>
            </ClayLayout.Row>
        </ClayLayout.ContentSection>
    );
};

export default WrapperComponent;

// /home/ignek/work/projects/DCIP/codebase/DCIP/liferay/client-extensions/lead-management-form-custom-element/public/images/hero.jpg